<template>
  <div>
    <div>
      <!-- Header Area -->
      <header class="main_header_area mha_2"></header>
      <!-- Header Area -->
      <vue-headful title="Credimóvil | Contrato Arrendamiento" :head="{
        'meta[charset]': { charset: 'utf-8' }
      }" />
      <menu-solicitud v-bind:use-apply-now="false"></menu-solicitud>
    </div>

    <section class="banner_area banner_area_8"></section>
    <!-- Banner Area -->
    <div class="container">
      <div class="d-flex justify-content-center row px-3">
        <button @click="showContract('ABasic')" class="m-2 btn btn-success">
          Basico
        </button>
        <button @click="showContract('Amoral')" class="m-2 btn btn-success">
          Moral
        </button>

        <button @click="showContract('Aendorsement')" class="m-2 btn btn-primary">
          Aval
        </button>

        <button @click="showContract('Abound')" class="m-2 btn btn-warning">
          Obligado
        </button>
        <button @click="showContract('AmoralAendorsement')" class="m-2 btn btn-primary">
          Aval Moral
        </button>

        <button @click="showContract('AmoralAbound')" class="m-2 btn btn-warning">
          Obligado Moral
        </button>

        <button @click="showContract('Amoralfull')" class="m-2 btn btn-success">
          Moral full
        </button>

        <!-- <button @click="showContract('both')" class="m-2 btn btn-success">
          Basico full
        </button> -->
      </div>

      <div class="d-flex justify-content-center row px-3">
        <button @click="showContract('Afisico')" class="m-2 btn btn-success">
          Fisica
        </button>
        <button @click="showContract('AfisicoAendorsement')" class="m-2 btn btn-primary">
          Aval Fisico
        </button>

        <button @click="showContract('AfisicoAbound')" class="m-2 btn btn-warning">
          Obligado Fisico
        </button>

        <button @click="showContract('Afisicofull')" class="m-2 btn btn-success">
          Fisico full
        </button>

        <button @click="showContract('ABasicfull')" class="m-2 btn btn-success">
          Basico full
        </button>
      </div>

      <div id="page1-div" ref="document" class="container interline">
        <v-pagareFederatario v-bind:data="data"></v-pagareFederatario>
      </div>
      <div class="d-flex justify-content-center row p-3">
        <button @click="generatePDF()" class="btn btn-success">
          Generar PDF
        </button>
      </div>
      <div class="container interline border page-container">
        <div class="col-12 row m-1">
          <div class="col-12 border border-dark auto bg-gpi-azulito text-center">
            <span class="ft10Black">Titular</span>
          </div>
          <div class="col-6 border border-dark auto bg-gpi-azulito">
            <span class="ft10Black">NOMBRE:</span>
          </div>
          <div class="col-6 border border-dark auto bg-gpi-azulito">
            <span class="ft10">{{ data.nombre_cliente }}</span>
          </div>
          <div class="col-6 border border-dark auto bg-gpi-azulito">
            <span class="ft10Black">LUGAR DE NACIMIENTO:</span>
          </div>
          <div class="col-6 border border-dark auto bg-gpi-azulito">
            <span class="ft10">{{ data.estado_nacimiento }}</span>
          </div>
          <div class="col-6 border border-dark auto bg-gpi-azulito">
            <span class="ft10Black">OCUPACION:</span>
          </div>
          <div class="col-6 border border-dark auto bg-gpi-azulito">
            <span class="ft10">{{ data.sector_empleo }}</span>
          </div>
          <div class="col-6 border border-dark auto bg-gpi-azulito">
            <span class="ft10Black">ESTADO CIVIL:</span>
          </div>
          <div class="col-6 border border-dark auto bg-gpi-azulito">
            <span class="ft10">{{ data.estado_civil }}</span>
          </div>
          <div class="col-6 border border-dark auto bg-gpi-azulito">
            <span class="ft10Black">FECHA DE NACIMIENTO:</span>
          </div>
          <div class="col-6 border border-dark auto bg-gpi-azulito">
            <span class="ft10">{{ data.fecha_nacimiento }}</span>
          </div>
          <div class="col-6 border border-dark auto bg-gpi-azulito">
            <span class="ft10Black">DOMICILIO:</span>
          </div>
          <div class="col-6 border border-dark auto bg-gpi-azulito">
            <span class="ft10">{{ data.calle_cliente }},
              {{ data.numero_calle_cliente }},
              {{ data.municipio_cliente }},
              {{ data.estado_cliente }},
              {{ data.codigo_postal_cliente }}
            </span>
          </div>
        </div>
        <div v-if="data.tipoAendorsement" class="col-12 row m-1">
          <div class="col-12 border border-dark auto bg-gpi-azulito text-center">
            <span class="ft10Black">Aval</span>
          </div>
          <div class="col-6 border border-dark auto bg-gpi-azulito">
            <span class="ft10Black">NOMBRE:</span>
          </div>
          <div class="col-6 border border-dark auto bg-gpi-azulito">
            <span class="ft10">{{ data.nombre_aval }}</span>
          </div>
          <div class="col-6 border border-dark auto bg-gpi-azulito">
            <span class="ft10Black">LUGAR DE NACIMIENTO:</span>
          </div>
          <div class="col-6 border border-dark auto bg-gpi-azulito">
            <span class="ft10">{{ data.estado_nacimiento_aval }}</span>
          </div>
          <div class="col-6 border border-dark auto bg-gpi-azulito">
            <span class="ft10Black">ESTADO CIVIL:</span>
          </div>
          <div class="col-6 border border-dark auto bg-gpi-azulito">
            <span class="ft10">{{ data.estado_civil_aval }}</span>
          </div>
          <div class="col-6 border border-dark auto bg-gpi-azulito">
            <span class="ft10Black">FECHA DE NACIMIENTO:</span>
          </div>
          <div class="col-6 border border-dark auto bg-gpi-azulito">
            <span class="ft10">{{ data.fecha_nacimiento_aval }}</span>
          </div>
          <div class="col-6 border border-dark auto bg-gpi-azulito">
            <span class="ft10Black">DOMICILIO:</span>
          </div>
          <div class="col-6 border border-dark auto bg-gpi-azulito">
            <span class="ft10">{{ data.calle_aval }},
              {{ data.numero_calle_aval }},
              {{ data.municipio_calle_aval }},
              {{ data.estado_calle_aval }},
              {{ data.codigo_postal_calle_aval }}
            </span>
          </div>
        </div>
        <div v-if="data.tipoAbound" class="col-12 row m-1">
          <div class="col-12 border border-dark auto bg-gpi-azulito text-center">
            <span class="ft10Black">Obligado</span>
          </div>
          <div class="col-6 border border-dark auto bg-gpi-azulito">
            <span class="ft10Black">NOMBRE:</span>
          </div>
          <div class="col-6 border border-dark auto bg-gpi-azulito">
            <span class="ft10">{{ data.nombre_obligado }}</span>
          </div>
          <div class="col-6 border border-dark auto bg-gpi-azulito">
            <span class="ft10Black">LUGAR DE NACIMIENTO:</span>
          </div>
          <div class="col-6 border border-dark auto bg-gpi-azulito">
            <span class="ft10">{{ data.estado_nacimiento_obligado }}</span>
          </div>
          <div class="col-6 border border-dark auto bg-gpi-azulito">
            <span class="ft10Black">ESTADO CIVIL:</span>
          </div>
          <div class="col-6 border border-dark auto bg-gpi-azulito">
            <span class="ft10">{{ data.estado_civil_obligado }}</span>
          </div>
          <div class="col-6 border border-dark auto bg-gpi-azulito">
            <span class="ft10Black">FECHA DE NACIMIENTO:</span>
          </div>
          <div class="col-6 border border-dark auto bg-gpi-azulito">
            <span class="ft10">{{ data.fecha_nacimiento_obligado }}</span>
          </div>
          <div class="col-6 border border-dark auto bg-gpi-azulito">
            <span class="ft10Black">DOMICILIO:</span>
          </div>
          <div class="col-6 border border-dark auto bg-gpi-azulito">
            <span class="ft10">{{ data.calle_obligado }},
              {{ data.numero_calle_obligado }},
              {{ data.municipio_obligado }},
              {{ data.estado_obligado }},
              {{ data.codigo_postal_obligado }}
            </span>
          </div>
        </div>
        <div v-if="data.tipoAmoral" class="col-12 row m-1">
          <div class="col-12 border border-dark auto bg-gpi-azulito text-center">
            <span class="ft10Black">Representante legal</span>
          </div>
          <div class="col-6 border border-dark auto bg-gpi-azulito">
            <span class="ft10Black">NOMBRE:</span>
          </div>
          <div class="col-6 border border-dark auto bg-gpi-azulito">
            <span class="ft10">{{ data.reprecentante_legal }}</span>
          </div>
          <div class="col-6 border border-dark auto bg-gpi-azulito">
            <span class="ft10Black">LUGAR DE NACIMIENTO:</span>
          </div>
          <div class="col-6 border border-dark auto bg-gpi-azulito">
            <span class="ft10">{{ data.estado_nacimiento_reprecentante }}</span>
          </div>
          <div class="col-6 border border-dark auto bg-gpi-azulito">
            <span class="ft10Black">ESTADO CIVIL:</span>
          </div>
          <div class="col-6 border border-dark auto bg-gpi-azulito">
            <span class="ft10">{{ data.estado_civil_reprecentante }}</span>
          </div>
          <div class="col-6 border border-dark auto bg-gpi-azulito">
            <span class="ft10Black">FECHA DE NACIMIENTO:</span>
          </div>
          <div class="col-6 border border-dark auto bg-gpi-azulito">
            <span class="ft10">{{ data.fecha_nacimiento_reprecentante }}</span>
          </div>
          <div class="col-6 border border-dark auto bg-gpi-azulito">
            <span class="ft10Black">DOMICILIO:</span>
          </div>
          <div class="col-6 border border-dark auto bg-gpi-azulito">
            <span class="ft10">{{ data.calle_reprecentante }},
              {{ data.numero_calle_reprecentante }},
              {{ data.municipio_reprecentante }},
              {{ data.estado_reprecentante }},
              {{ data.codigo_postal_reprecentante }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import html2pdf from "html2pdf.js";
import moment from "moment";
import environment from "../../environments/Environment";
import pagareFederatario from "./pagare/Pagare_federatario.vue";

let now = new Date();
var meses = new Array(
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre"
);

export default {
  name: "PagareFederatario",
  data() {
    return {
      acepted: false,
      clickupId: "",
      fecha_primer_pago: "",
      comisionApertura: environment.COMISION_APERTURA,

      data: {
        gps_sin_iva: environment.GPS_SIN_IVA,
        sdd_sin_iva: environment.SEGURODEUDOR_SIN_IVA,
        tipoAval: false,
        tipoABasic: true,
        tipoObligado: false,
        tipoAmoral: false,
        showMarca: true,
        telefono: "telefono",
        nombre_cliente: "nombre_cliente",
        correo: "correo",
        genero: "genero",
        CURP: "CURP",
        estado_civil: "estado_civil",
        estado_nacimiento: "estado_nacimiento",
        fecha_nacimiento: "fecha_nacimiento",
        edad: "edad",
        estado_cliente: "estado_cliente",
        municipio_cliente: "municipio_cliente",
        colonia_cliente: "colonia_cliente",
        numero_calle_cliente: "numero_calle_cliente",
        codigo_postal_cliente: "codigo_postal_cliente",
        calle_cliente: "calle_cliente",
        estatus_vivienda_cliente: "estatus_vivienda_cliente",
        vivienda_desde: "vivienda_desde",
        numero_cheque: "numero_cheque",
        RFC: "RFC_cliente",
        fecha_contrato:
          now.getDate() +
          " de " +
          meses[now.getMonth()] +
          " del " +
          now.getFullYear(),

        plazo: "plazo",
        monto_a_finaciar: "monto_a_finaciar",
        monto_a_finaciar_letra: "monto_a_finaciar_letra",
        mensualidad: "mensualidad",
        mensualidad_letra: "mensualidad_letra",
        monto_total: "monto_total",
        monto_total_letra: "monto_total_letra",
        monto_total_residual: "monto_total_residual",
        monto_total_residual_letra: "monto_total_residual_letra",
        precio_vehiculo: "precio_vehiculo",
        enganche: "enganche",
        enganche_letra: "enganche",

        tipo_vehiculo: "tipo_vehiculo",
        marca_vehiculo: "marca_vehiculo",
        modelo_vehiculo: "modelo_vehiculo",
        año_vehiculo: "año_vehiculo",
        seguro_vehiculo: "seguro_vehiculo",

        tasa_ordinaria: "00.00",
        moratorio: environment.MORATORIO,
        moratorio_letra: "OCHO PORCIENTO",
        cat_anual: environment.CAT_ANUAL,

        nombre_empresa: "nombre_empresa",
        situcion_empleo: "situcion_empleo",
        sector_empleo: "sector_empleo",

        ingreso_mensual: "ingreso_mensual",
        ingreso_variable: "ingreso_variable",
        ingreso_otro: "ingreso_otro",
        ingreso_familiar: "ingreso_familiar",

        nombre_referecnia_1: "nombre_referecnia_1",
        telefono_referecnia_1: "telefono_referecnia_1",
        tipo_referecnia_1: "tipo_referecnia_1",
        nombre_referecnia_2: "nombre_referecnia_2",
        telefono_referecnia_2: "telefono_referecnia_2",
        tipo_referecnia_2: "tipo_referecnia_2",
        nombre_referecnia_3: "nombre_referecnia_3",
        telefono_referecnia_3: "telefono_referecnia_3",
        tipo_referecnia_3: "tipo_referecnia_3",

        banco: "BANORTE",
        cuenta_banco: "0420253088",
        clave_banco: "072320004202530888",

        año_contrato: now.getFullYear(),

        nombre_aval: "nombre_aval",
        calle_aval: "calle_aval",
        numero_calle_aval: "numero_calle_aval",
        colonia_aval: "colonia_aval",
        estado_aval: "estado_aval",
        codigo_postal_aval: "codigo_postal_aval",
        RFC_aval: "rfc_aval",
        CURP_aval: "CURP_aval",
        estado_nacimiento_aval: "estado_nacimiento_aval",
        sector_empleo_aval: "sector_empleo",
        estado_civil_aval: "estado_civil_aval",
        fecha_nacimiento_aval: "fecha_nacimiento_aval",

        nombre_obligado: "nombre_obligado",
        calle_obligado: "calle_obligado",
        numero_calle_obligado: "numero_calle_obligado",
        colonia_obligado: "colonia_obligado",
        estado_obligado: "estado_obligado",
        codigo_postal_obligado: "codigo_postal_obligado",
        RFC_Obligado: "RFC_Obligado",
        CURP_Obligado: "CURP_Obligado",
        estado_nacimiento_obligado: "estado_nacimiento_obligado",
        sector_empleo_obligado: "sector_empleo",
        estado_civil_obligado: "estado_civil_obligado",
        fecha_nacimiento_obligado: "fecha_nacimiento_obligado",

        seguro_nombre: "seguro_nombre",
        seguro_covertura: "seguro_covertura",
        precio_seguro: "precio_seguro",
        numero_serie_vehiculo: "numero_serie_vehiculo",
        numero_motor_vehiculo: "numero_motor_vehiculo",
        placa_vehiculo: "placa_vehiculo",
        numero_factura: "numero_factura",
        fecha_factura: "xx xx fecha_factura x",
        emisor_factura: "emisor_factura",

        //TODO:estatos aun no los tenemos
        periodicidad: "MENSUAL",
        valor_comercial_vehiculo: "valor_comercial_vehiculo",
        residual_percentage: "residual_percentage",

        fecha_primer_pago: "fecha_primer_pago",
        fecha_ultimo_pago: "fecha_ultimo_pago",
        fecha_ultimo_pago_residual: "fecha_ultimo_pago_residual",
        dias_de_abono: "10",

        referencia_banco: "referencia_banco",
        No_Operacion_Cliente: "No_Operacion_Cliente",
        pago_tercero: "NOMBRE PAGO A TERCEROS",
        lote: "LOTE",
        nombre_asesor: "nombre_asesor",
        arrayFechas: [],

        reprecentante_legal: "reprecentante_legal",
        CURP_reprecentante_legal: "CURP_reprecentante_legal",
        RFC_reprecentante_legal: "RFC_reprecentante_legal",
        escritura_reprecentante_legal: "escritura_reprecentante_legal",

        numero_mercantil: "numero_mercantil",
        folio_mercantil: "folio_mercantil",
        escritura_publica: "escritura_publica",
        escritura_fecha: "escritura_fecha",
        escritura_licenciado: "escritura_licenciado",

        notaria: "notaria",
        numero_notaria: "numero_notaria",
        estado_notaria: "estado_notaria",
        municipio_notaria: "municipio_notaria",
        estado_registro: "estado_registro",
        municipio_registro: "municipio_registro",

        numero_mercantil_reprecentante: "numero_mercantil",
        folio_mercantil_reprecentante: "folio_mercantil",
        escritura_publica_reprecentante: "escritura_publica",
        escritura_fecha_reprecentante: "escritura_fecha",
        escritura_licenciado_reprecentante: "escritura_licenciado",

        notaria_reprecentante: "notaria",
        numero_notaria_reprecentante: "numero_notaria",
        estado_notaria_reprecentante: "estado_notaria",
        municipio_notaria_reprecentante: "municipio_notaria",

        comision_apertura: "0",

        tipoAendorsement: false,
        tipoABasic: true,
        tipoAbound: false,
        tipoAmoral: false,
      }
    };
  },
  validations() {
    return {};
  },
  components: {
    "v-pagareFederatario": pagareFederatario
  },
  methods: {
    generatePDF() {
      this.preloader();
      this.data.showMarca = false;

      const elements = document.querySelectorAll(".page-container");
      elements.forEach(element => {
        element.classList.remove("border");
      });

      html2pdf(this.$refs.document, {
        margin: 1,
        filename:
          "PagareFederatario_" +
          this.data.nombre_cliente +
          ".pdf",
        image: { type: "jpeg", quality: 2 },
        html2canvas: {
          scale: 2,
          dpi: 600,
          letterRendering: true,
          allowTaint: true,
          useCORS: true,
          imageTimeout: 35000,
          logging: true
        },
        jsPDF: { unit: "mm", format: "a4", orientation: "p", compress: true }
      }).then(result => {
        this.data.showMarca = true;
        elements.forEach(element => {
          element.classList.add("border");
        });
        this.preloaderHiden();
      });
    },
    getUser() {
      this.$UserService.getUser().then(
        result => {
          if (result.data.length > 0) {
            this.clickupId = result.data[0].clickup_task;
            this.data.telefono = result.data[0].phone;
            this.data.correo = result.data[0].email;
          }
        },
        err => {
          this.$swal("CUIDADO!", err.msg, "error");
          this.preloaderHiden();
        }
      );
    },
    getUserReprentante() {
      this.$UserService.getUserReprentante().then(
        result => {
          if (result.data.length > 0) {
            this.data.reprecentante_legal = result.data[0].last_name
              ? result.data[0].father_name +
              " " +
              result.data[0].mother_name +
              " " +
              result.data[0].first_name +
              " " +
              result.data[0].last_name
              : result.data[0].father_name +
              " " +
              result.data[0].mother_name +
              " " +
              result.data[0].first_name;

            this.data.RFC_reprecentante_legal = result.data[0].RFC.toUpperCase();
            this.data.CURP_reprecentante_legal = result.data[0].CURP.toUpperCase();

            this.data.escritura_licenciado_reprecentante = result.data[0].escritura_licenciado;
            this.data.notaria_reprecentante = result.data[0].notaria;
            this.data.numero_notaria_reprecentante = result.data[0].numero_notaria;
            this.data.estado_notaria_reprecentante = result.data[0].estado_notaria;
            this.data.municipio_notaria_reprecentante = result.data[0].municipio_notaria;
            this.data.folio_mercantil_reprecentante = result.data[0].folio_mercantil;

            let escritura_fecha = new Date(
              result.data[0].escritura_fecha
            );
            this.data.escritura_fecha_reprecentante =
              (escritura_fecha.getDate() +
                1 +
                " de " +
                meses[escritura_fecha.getMonth()] +
                " del " +
                escritura_fecha.getFullYear()) || "FECHA FACTURA NO ASIGNADA";

            this.data.escritura_publica_reprecentante = result.data[0].escritura_publica;

            this.data.estado_civil_reprecentante = result.data[0].marital_status.toUpperCase();
            this.data.nombre_cliente_reprecentante = this.data.nombre_cliente.toUpperCase();
            this.data.estado_nacimiento_reprecentante = result.data[0].state_dob.toUpperCase();
            this.data.fecha_nacimiento_reprecentante = moment(
              result.data[0].DOB,
              "YYYY-MM-DD"
            ).format("DD-MM-YYYY");

            if (result.data.length > 1) {
              this.data.calle_reprecentante = result.data[1].street.toUpperCase();
              this.data.numero_calle_reprecentante = result.data[1].address_no.toUpperCase();
              this.data.estado_reprecentante = result.data[1].state.toUpperCase();
              this.data.municipio_reprecentante = result.data[1].town.toUpperCase();
              this.data.colonia_reprecentante = result.data[1].suburb.toUpperCase();
              this.data.codigo_postal_reprecentante = result.data[1].postcode.toUpperCase();
            }
          }
        },
        err => {
          console.log("-------------------------");
          console.log(err);
          this.$swal("CUIDADO!", err.msg, "error");
          this.preloaderHiden();
        }
      );
    },
    getUserAval() {
      this.$UserService.getUserAval().then(
        result => {
          if (result.data.length > 0) {
            this.data.nombre_aval = result.data[0].last_name
              ? result.data[0].father_name +
              " " +
              result.data[0].mother_name +
              " " +
              result.data[0].first_name +
              " " +
              result.data[0].last_name
              : result.data[0].father_name +
              " " +
              result.data[0].mother_name +
              " " +
              result.data[0].first_name;

            this.data.RFC_aval = result.data[0].RFC.toUpperCase();
            this.data.CURP_aval = result.data[0].CURP.toUpperCase();

            this.data.estado_civil_aval = (result.data[0].marital_status || "").toUpperCase();
            this.data.nombre_cliente_aval = this.data.nombre_cliente.toUpperCase();
            this.data.estado_nacimiento_aval = result.data[0].state_dob.toUpperCase();
            this.data.fecha_nacimiento_aval = moment(
              result.data[0].DOB,
              "YYYY-MM-DD"
            ).format("DD-MM-YYYY");
          }
          if (result.data.length > 1) {
            this.data.calle_aval = result.data[1].street.toUpperCase();
            this.data.numero_calle_aval = result.data[1].address_no.toUpperCase();
            this.data.estado_aval = result.data[1].state.toUpperCase();
            this.data.municipio_aval = result.data[1].town.toUpperCase();
            this.data.colonia_aval = result.data[1].suburb.toUpperCase();
            this.data.codigo_postal_aval = result.data[1].postcode.toUpperCase();
          }
        },
        err => {
          console.log("-------------------------");
          console.log(err);
          this.$swal("CUIDADO!", err.msg, "error");
          this.preloaderHiden();
        }
      );
    },
    getUserObligado() {
      this.$UserService.getUserObligado().then(
        result => {
          if (result.data.length > 0) {

            this.data.RFC_Obligado = result.data[0].RFC.toUpperCase();
            this.data.CURP_Obligado = result.data[0].CURP.toUpperCase();
            this.data.nombre_obligado = result.data[0].last_name
              ? result.data[0].father_name +
              " " +
              result.data[0].mother_name +
              " " +
              result.data[0].first_name +
              " " +
              result.data[0].last_name
              : result.data[0].father_name +
              " " +
              result.data[0].mother_name +
              " " +
              result.data[0].first_name;
          }
          this.data.estado_civil_obligado = result.data[0].marital_status.toUpperCase();
          this.data.nombre_cliente_obligado = this.data.nombre_cliente.toUpperCase();
          this.data.estado_nacimiento_obligado = result.data[0].state_dob.toUpperCase();
          this.data.fecha_nacimiento_obligado = moment(
            result.data[0].DOB,
            "YYYY-MM-DD"
          ).format("DD-MM-YYYY");
          if (result.data.length > 1) {
            this.data.calle_obligado = result.data[1].street.toUpperCase();
            this.data.numero_calle_obligado = result.data[1].address_no.toUpperCase();
            this.data.estado_obligado = result.data[1].state.toUpperCase();
            this.data.municipio_obligado = result.data[1].town.toUpperCase();
            this.data.colonia_obligado = result.data[1].suburb.toUpperCase();
            this.data.codigo_postal_obligado = result.data[1].postcode.toUpperCase();
          }
        },
        err => {
          this.$swal("CUIDADO!", err.msg, "error");
          this.preloaderHiden();
        }
      );
    },
    getUserDetaill() {
      this.$UserService.getDetails().then(
        result => {
          if (result.data.length > 0) {
            this.data.CURP = result.data[0].CURP.toUpperCase();
            this.data.genero = result.data[0].gender.toUpperCase();
            this.data.RFC = result.data[0].RFC.toUpperCase();
            this.data.nombre_cliente = result.data[0].last_name
              ? result.data[0].father_name +
              " " +
              result.data[0].mother_name +
              " " +
              result.data[0].first_name +
              " " +
              result.data[0].last_name
              : result.data[0].father_name +
              " " +
              result.data[0].mother_name +
              " " +
              result.data[0].first_name;
            this.data.estado_civil = result.data[0].marital_status.toUpperCase();
            this.data.nombre_cliente = this.data.nombre_cliente.toUpperCase();
            this.data.estado_nacimiento = result.data[0].state_dob.toUpperCase();
            this.data.fecha_nacimiento = moment(
              result.data[0].DOB,
              "YYYY-MM-DD"
            ).format("DD-MM-YYYY");
            //this.data.estado_cliente = result.data[0].state_dob;


            this.data.escritura_publica = result.data[0].escritura_publica;
            let escritura_fecha = new Date(
              result.data[0].escritura_fecha
            );
            this.data.escritura_fecha =
              (escritura_fecha.getDate() +
                1 +
                " de " +
                meses[escritura_fecha.getMonth()] +
                " del " +
                escritura_fecha.getFullYear()) || "FECHA FACTURA NO ASIGNADA";

            this.data.escritura_licenciado = result.data[0].escritura_licenciado;
            this.data.notaria = result.data[0].notaria;
            this.data.numero_notaria = result.data[0].numero_notaria;
            this.data.estado_notaria = result.data[0].estado_notaria;
            this.data.municipio_notaria = result.data[0].municipio_notaria;
            this.data.folio_mercantil = result.data[0].folio_mercantil;

            this.data.municipio_registro = result.data[0].estado_registro;
            this.data.estado_registro = result.data[0].municipio_registro;
          }
          this.preloaderHiden();
        },
        err => {
          this.$swal("CUIDADO!", err.msg, "error");
          this.preloaderHiden();
        }
      );
    },
    getUserAddress() {
      this.$UserService.getAddress().then(
        result => {
          if (result.data.length > 0) {
            this.data.calle_cliente = result.data[0].street.toUpperCase();
            this.data.numero_calle_cliente = result.data[0].address_no.toUpperCase();
            this.data.estado_cliente = result.data[0].state.toUpperCase();
            this.data.municipio_cliente = result.data[0].town.toUpperCase();
            this.data.colonia_cliente = result.data[0].suburb.toUpperCase();
            this.data.codigo_postal_cliente = result.data[0].postcode.toUpperCase();

            this.data.vivienda_desde = result.data[0].living_since.toUpperCase();
            this.data.estatus_vivienda_cliente = result.data[0].current_living.toUpperCase();
          }
          this.preloaderHiden();
        },
        err => {
          this.$swal("CUIDADO!", err.msg, "error");
          this.preloaderHiden();
        }
      );
    },
    getQuotationMoral() {
      this.$UserService.getCreditQuotation().then(
        result => {
          if (result.data.length > 0) {

            this.data.precio_vehiculo = result.data[0].vehicle_price;
            this.data.enganche = result.data[0].vehicle_hitch;
            this.data.seguro_vehiculo = result.data[0].insurance_payment.toUpperCase();
            this.data.monto_a_finaciar_sin_seguro = result.data[0].requested_amount_credit;
            this.data.type_quote = result.data[0].type_quote;
            this.data.residual_percentage = result.data[0].residual_percentage;

            if (this.data.seguro_vehiculo.toUpperCase() == "FINANCIADO") {
              this.data.monto_a_finaciar =
                Number(result.data[0].requested_amount_credit) +
                Number(this.data.precio_seguro);
            } else {
              this.data.monto_a_finaciar =
                result.data[0].requested_amount_credit;
            }

            this.data.monto_total_residual =
              ((this.data.precio_vehiculo *
                ((result.data[0].residual_percentage) / 100)) *
                1.16).toFixed(2);
            this.data.lote = (result.data[0].lote || "").toUpperCase();
            this.data.plazo = result.data[0].months;
            this.data.tasa_ordinaria = (
              this.data.tasa * 12 //this.data.plazo
            ).toFixed(2);


            this.data.mensualidad =
              ((((Number(this.data.monto_a_finaciar) * (this.data.tasa / 100)) /
                (1 - Math.pow(1 + (this.data.tasa / 100), - this.data.plazo)))
                +
                ((Number(this.data.monto_total_residual / 1.16) * (this.data.tasa / 100)) /
                  (1 - Math.pow(1 + (this.data.tasa / 100), this.data.plazo)))
                + Number(this.data.gps_sin_iva) + Number(this.data.sdd_sin_iva)) * 1.16).toFixed(2)

            this.data.comision_apertura = (this.data.precio_vehiculo * (this.comisionApertura / 100)).toFixed(2);
            this.data.monto_total = (this.data.mensualidad * this.data.plazo).toFixed(2);
            this.data.tipo_vehiculo = result.data[0].vehicle_type.toUpperCase();
            this.data.marca_vehiculo = result.data[0].vehicle_brand.toUpperCase();
            this.data.modelo_vehiculo = result.data[0].vehicle_model.toUpperCase();
            this.data.año_vehiculo = result.data[0].vehicle_version.toUpperCase();

            this.data.arrayFechas.push(this.data.fecha_primer_pago);
            for (let index = 1; index < this.data.plazo / 12; index++) {
              let date =
                this.fecha_primer_pago.getDate() +
                1 +
                " de " +
                meses[this.fecha_primer_pago.getMonth()] +
                " del " +
                (this.fecha_primer_pago.getFullYear() + index) ||
                "FECHA FACTURA NO ASIGNADA";
              this.data.arrayFechas.push(date);
            }

          }
          this.preloaderHiden();
        },
        err => {

          console.log("---------errror --------------------");
          this.$swal("CUIDADO!", err.msg, "error");
          this.preloaderHiden();
        }
      );
    },
    getQuotation() {
      this.$UserService.getCreditQuotation().then(
        result => {
          if (result.data.length > 0) {
            this.data.precio_vehiculo = result.data[0].vehicle_price;
            this.data.enganche = result.data[0].vehicle_hitch;
            this.data.seguro_vehiculo = result.data[0].insurance_payment.toUpperCase();
            this.data.monto_a_finaciar_sin_seguro = result.data[0].requested_amount_credit;

            if (this.data.seguro_vehiculo.toUpperCase() == "FINANCIADO") {
              this.data.monto_a_finaciar =
                result.data[0].requested_amount_credit +
                this.data.precio_seguro;
            } else {
              this.data.monto_a_finaciar =
                result.data[0].requested_amount_credit;
            }

            this.data.lote = (result.data[0].lote || "").toUpperCase();
            this.data.plazo = result.data[0].months;
            this.data.tasa_ordinaria = (
              this.data.tasa * 12 //this.data.plazo
            ).toFixed(2);
            this.data.mensualidad = (
              ((this.data.monto_a_finaciar / this.data.plazo) +
                (this.data.monto_a_finaciar * (this.data.tasa / 100))) +
              (environment.GPS + environment.SEGURODEUDOR)
            ).toFixed(2);
            this.data.monto_total = (this.data.mensualidad * this.data.plazo).toFixed(2);
            this.data.tipo_vehiculo = result.data[0].vehicle_type.toUpperCase();
            this.data.marca_vehiculo = result.data[0].vehicle_brand.toUpperCase();
            this.data.modelo_vehiculo = result.data[0].vehicle_model.toUpperCase();
            this.data.año_vehiculo = result.data[0].vehicle_version.toUpperCase();
          }
          this.preloaderHiden();
        },
        err => {
          this.$swal("CUIDADO!", err.msg, "error");
          this.preloaderHiden();
        }
      );
    },
    getEmployement() {
      this.$UserService.getEmployement().then(
        result => {
          if (result.data.length > 0) {
            this.data.ingreso_mensual = result.data[0].net_income;
            this.data.ingreso_variable = result.data[0].verifiable_income;
            this.data.ingreso_familiar = result.data[0].family_income;
            this.data.verifiable_income = result.data[0].unverifiable_income;

            this.data.nombre_empresa = result.data[0].company_name;
            this.data.situcion_empleo = result.data[0].employment_situation;
            this.data.sector_empleo = result.data[0].line_of_business;
          }
        },
        err => {
          this.$swal("CUIDADO!", err.msg, "error");
          this.preloaderHiden();
        }
      );
    },
    getReference() {
      this.$UserService.getReference().then(
        result => {
          if (result.data.length > 0) {
            this.data.nombre_referecnia_1 = result.data[0].name;
            this.data.telefono_referecnia_1 = result.data[0].phone;
            this.data.tipo_referecnia_1 = result.data[0].type;
          }
          if (result.data.length >= 2) {
            this.data.nombre_referecnia_2 = result.data[1].name;
            this.data.telefono_referecnia_2 = result.data[1].phone;
            this.data.tipo_referecnia_2 = result.data[1].type;
          }
          if (result.data.length >= 3) {
            this.data.nombre_referecnia_3 = result.data[2].name;
            this.data.telefono_referecnia_3 = result.data[2].phone;
            this.data.tipo_referecnia_3 = result.data[2].type;
          }
        },
        err => {
          this.$swal("CUIDADO!", err.msg, "error");
          this.preloaderHiden();
        }
      );
    },
    getInsurce() {
      this.$InsuranceService.getInsurce().then(
        result => {
          if (result.data.length > 0) {
            this.data.seguro_nombre = result.data[0].insurce_name;
            this.data.seguro_covertura = result.data[0].insurance_coverage;
            this.data.precio_seguro = result.data[0].insurce_price;
            this.data.numero_serie_vehiculo = result.data[0].serial_number_vehicle.toUpperCase();
            this.data.numero_motor_vehiculo = result.data[0].engine_number_vehicle.toUpperCase();
            this.data.placa_vehiculo = result.data[0].car_license_plates;
            this.data.numero_factura = result.data[0].invoice_number;
            this.data.emisor_factura = result.data[0].invoice_issuer;

            let fecha_factura = new Date(result.data[0].invoice_date);
            this.data.fecha_factura =
              fecha_factura.getDate() +
              " de " +
              meses[fecha_factura.getMonth()] +
              " del " +
              fecha_factura.getFullYear() || "FECHA FACTURA NO ASIGNADA";
          }
        },
        err => {
          console.log(err);
          this.$swal("CUIDADO!", err.msg, "error");
          this.preloaderHiden();
        }
      );
    },
    getContract() {
      this.$UserService.getContract().then(
        result => {
          if (result.data.length > 0) {
            this.data.referencia_banco = result.data[0].referencia_banco;
            this.data.nombre_asesor = (
              result.data[0].nombre_asesor || ""
            ).toUpperCase();
            this.data.No_Operacion_Cliente = result.data[0].numero_operacion;
            this.data.valor_comercial_vehiculo =
              result.data[0].valor_comercial_vehiculo;
            this.fecha_primer_pago = new Date(
              result.data[0].fecha_primer_pago
            );
            let fecha_ultimo_pago = new Date(result.data[0].fecha_ultimo_pago);
            this.data.dias_de_abono = result.data[0].dia_pago;
            this.data.periodicidad = result.data[0].frecuencia;
            this.data.tasa = result.data[0].tasa;
            this.data.pago_tercero = result.data[0].nombre_pago_terceros;

            this.data.fecha_primer_pago =
              this.fecha_primer_pago.getDate() +
              1 +
              " de " +
              meses[this.fecha_primer_pago.getMonth()] +
              " del " +
              this.fecha_primer_pago.getFullYear() || "FECHA FACTURA NO ASIGNADA";

            fecha_ultimo_pago.setDate(fecha_ultimo_pago.getDate() + 1);
            this.data.fecha_ultimo_pago =
              fecha_ultimo_pago.getDate() +
              " de " +
              meses[fecha_ultimo_pago.getMonth()] +
              " del " +
              fecha_ultimo_pago.getFullYear() || "FECHA FACTURA NO ASIGNADA";

            fecha_ultimo_pago.setDate(fecha_ultimo_pago.getMonth() - 1);
            this.data.fecha_ultimo_pago_residual =
              fecha_ultimo_pago.getDate() +
              " de " +
              meses[fecha_ultimo_pago.getMonth()] +
              " del " +
              fecha_ultimo_pago.getFullYear() || "FECHA FACTURA NO ASIGNADA";


            if (result.data[0].gps == 0) {
              this.data.gps_sin_iva = 0
            }

            if (result.data[0].sdd == 0) {
              this.data.sdd_sin_iva = 0
            }
          }
        },
        err => {
          console.log(err);
          this.$swal("CUIDADO!", err.msg, "error");
          this.preloaderHiden();
        }
      );
    },
    getNumberLetter() {
      this.$UtilityService
        .NumeroALetras(this.data.mensualidad, {})
        .then(result => {
          this.data.mensualidad_letra = result;
        });
      this.$UtilityService
        .NumeroALetras(this.data.enganche, {})
        .then(result => {
          this.data.enganche_letra = result;
        });
      this.$UtilityService
        .NumeroALetras(this.data.monto_total, {})
        .then(result => {
          this.data.monto_total_letra = result;
        });
      this.$UtilityService
        .NumeroALetras(this.data.monto_total_residual, {})
        .then(result => {
          this.data.monto_total_residual_letra = result;
        });
      this.$UtilityService
        .NumeroALetras(this.data.monto_a_finaciar, {})
        .then(result => {
          this.data.monto_a_finaciar_letra = result;
        });
      this.$UtilityService
        .NumeroALetras(this.data.precio_seguro, {})
        .then(result => {
          this.data.precio_seguro_letra = result;
        });
    },
    getNumberMoneda() {

      this.data.monto_total = this.$UtilityService.FormatoMoneda(
        parseFloat(this.data.monto_total)
      );
      this.data.monto_total_residual = this.$UtilityService.FormatoMoneda(
        parseFloat(this.data.monto_total_residual)
      );
      this.data.monto_a_finaciar = this.$UtilityService.FormatoMoneda(
        parseFloat(this.data.monto_a_finaciar)
      );
      this.data.precio_seguro = this.$UtilityService.FormatoMoneda(
        parseFloat(this.data.precio_seguro)
      );
      this.data.enganche = this.$UtilityService.FormatoMoneda(
        parseFloat(this.data.enganche)
      );
      this.data.mensualidad = this.$UtilityService.FormatoMoneda(
        parseFloat(this.data.mensualidad)
      );
    },
    fillData() {

      this.preloader();
      this.getUser();
      this.getContract();
      this.getInsurce();
      this.getUserDetaill();
      this.getUserAddress();
      this.getEmployement();
      this.getReference();
      this.getUserObligado();
      this.getUserAval();
      this.getUserReprentante();
      this.getQuotation();
      setTimeout(() => {
        this.getNumberLetter();
        setTimeout(() => {
          this.getNumberMoneda();
          this.preloaderHiden();
        }, 2000);
      }, 4000);
    },
    fillDataMoral() {

      this.preloader();
      this.getUser();
      this.getContract();
      this.getInsurce();
      this.getUserDetaill();
      this.getUserAddress();
      this.getEmployement();
      this.getReference();
      this.getUserObligado();
      this.getUserAval();
      this.getUserReprentante();
      this.getQuotationMoral();
      setTimeout(() => {
        this.getNumberLetter();
        setTimeout(() => {
          this.getNumberMoneda();
          this.preloaderHiden();
        }, 2000);
      }, 4000);
    },
    showContract(type) {

      let fecha_contrato = new Date();
      fecha_contrato.setDate(fecha_contrato.getDate() +
        this.data.estado_cliente == 'CIUDAD DE MÉXICO' ||
        this.data.estado_cliente == 'ESTADO DE MÉXICO' ? 1 : 0);
      this.data.fecha_contrato =
        fecha_contrato.getDate() +
        " de " +
        meses[fecha_contrato.getMonth()] +
        " del " +
        fecha_contrato.getFullYear() || "FECHA FACTURA NO ASIGNADA";
      switch (type) {
        case "ABasic":
          this.data.tipoAendorsement = false;
          this.data.tipoABasic = true;
          this.data.tipoAbound = false;
          this.data.tipoAmoral = false;
          this.fillData();
          break;
        case "Aendorsement":
          this.data.tipoAendorsement = true;
          this.data.tipoABasic = true;
          this.data.tipoAbound = false;
          this.data.tipoAmoral = false;
          this.fillData();
          break;
        case "Abound":
          this.data.tipoAendorsement = false;
          this.data.tipoABasic = true;
          this.data.tipoAbound = true;
          this.data.tipoAmoral = false;
          this.fillData();
          break;
        case "Amoral":
          this.data.tipoAendorsement = false;
          this.data.tipoABasic = true;
          this.data.tipoAbound = false;
          this.data.tipoAmoral = true;
          this.fillDataMoral();
          break;
        case "AmoralAendorsement":
          this.data.tipoAendorsement = true;
          this.data.tipoABasic = true;
          this.data.tipoAbound = false;
          this.data.tipoAmoral = true;
          this.fillDataMoral();
          break;
        case "AmoralAbound":
          this.data.tipoAendorsement = false;
          this.data.tipoABasic = true;
          this.data.tipoAbound = true;
          this.data.tipoAmoral = true;
          this.fillDataMoral();
          break;
        case "Amoralfull":
          this.data.tipoAendorsement = true;
          this.data.tipoABasic = true;
          this.data.tipoAbound = true;
          this.data.tipoAmoral = true;
          this.data.tipoAbout = true;
          this.fillDataMoral();
          break;
        case "Afisico":
          this.data.tipoAendorsement = false;
          this.data.tipoABasic = true;
          this.data.tipoAbound = false;
          this.data.tipoAmoral = false;
          this.fillDataMoral();
          break;
        case "AfisicoAendorsement":
          this.data.tipoAendorsement = true;
          this.data.tipoABasic = true;
          this.data.tipoAbound = false;
          this.data.tipoAmoral = false;
          this.fillDataMoral();
          break;
        case "AfisicoAbound":
          this.data.tipoAendorsement = false;
          this.data.tipoABasic = true;
          this.data.tipoAbound = true;
          this.data.tipoAmoral = false;
          this.fillDataMoral();
          break;
        case "Afisicofull":
          this.data.tipoAendorsement = true;
          this.data.tipoABasic = true;
          this.data.tipoAbound = true;
          this.data.tipoAmoral = false;
          this.data.tipoAbout = false;
          this.fillDataMoral();
          break;
        case "ABasicfull":
        this.data.tipoAendorsement = true;
          this.data.tipoABasic = true;
          this.data.tipoAbound = true;
          this.data.tipoAmoral = false;
          this.data.tipoAbout = false;
          this.fillData();
          break;
        default:
          this.$swal
            .fire("CUIDADO!", "Direccion invalida", "error")
            .then(result => {
              window.location = "/pre-approval";
              this.getContract();
            });
          break;
      }
    },
    preloader() {
      //let elem = document.getElementById('id_preloader');

      $(".preloader").fadeIn();
      $(".preloader")
        .delay(10)
        .fadeIn("slow");

      //elem.classList.add('fade');


    },
    preloaderHiden() {
      $(".preloader").fadeOut();
      $(".preloader")
        .delay(10)
        .fadeOut("slow");
    }
  },
  created() {
    this.fillData();
    //this.showContract();
    window.scrollTo(0, 0);
  }
};
</script>
<style type="text/scss">
@import "./style.scss";
</style>



// WEBPACK FOOTER //
// src/views/contratoArrendamiento/PagareFederatario.vue